module.exports = __webpack_public_path__ + "static/media/Immobilier-Vaud-1.787aee9a.jpg";